import { LS } from "./constants";
import { safeGet, genFallbackId, safeSet } from "./helpers";

// Extend window type so TS stops complaining
declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

// Safe push wrapper
export function gtmPush(event: string, payload: Record<string, any> = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...payload,
  });
}

export function getOrCreateAttribId() {
  let id = safeGet(LS.ATTR_ID);
  if (!id) {
    id = genFallbackId("ao");
    safeSet(LS.ATTR_ID, id);
    safeSet(LS.FIRST_TOUCH_TS, Date.now());
  }
  return id;
}

export function buildAcqPayload() {
  return {
    acquisition_attrib_id: safeGet(LS.ATTR_ID) || getOrCreateAttribId(),
    acquisition_channel: "online_account",
    utm_source: safeGet(LS.UTM_SOURCE),
    utm_medium: safeGet(LS.UTM_MEDIUM),
    utm_campaign: safeGet(LS.UTM_CAMPAIGN),
    utm_term: safeGet(LS.UTM_TERM),
    gclid: safeGet(LS.GCLID),
    fbclid: safeGet(LS.FBC),
    ttclid: safeGet(LS.TTCLID),
    twclid: safeGet(LS.TWCLID),
    snapclid: safeGet(LS.SNAPCLID) || safeGet(LS.CLICK_ID),
    ga_client_id: safeGet(LS.GA_CLIENT_ID),
    first_touch_ts: safeGet(LS.FIRST_TOUCH_TS),
  };
}
